import { PickersDay, PickersDayProps } from "@mui/x-date-pickers/PickersDay";

export type { PickersDayProps };

export default PickersDay;
